export default __webpack_public_path__ + "static/media/9.10763591.jpeg";